/**
 * @fileoverview Color palettes and emoji options for particle customization
 */

/**
 * Dark mode color palette
 */
export const darkColorPalette = [
  '#ff007b',
  '#33ff57',
  '#3357ff',
  '#ffc300',
  '#ffffff',
  '#ad55ff',
  '#00f5d4',
  '#f15bb5',
];

/**
 * Light mode color palette
 */
export const lightColorPalette = [
  '#f72585',
  '#7209b7',
  '#3a0ca3',
  '#4361ee',
  '#4cc9f0',
  '#f94144',
  '#f3722c',
  '#f9c74f',
];

/**
 * Background colors by theme
 */
export const THEME_BACKGROUNDS = {
  DARK: '#111',
  LIGHT: '#f0f0f0',
};

/**
 * Trail fill colors by theme
 */
export const TRAIL_COLORS = {
  DARK: '#111',
  LIGHT: '#f0f0f0',
};

/**
 * Emoji pool used to build the shortened share-URL slug (see createEmojiShortUrl).
 * Not used for particle rendering — the character/emoji particle shape was removed.
 */
export const emojiOptions = [
  '🐎',
  '🐴',
  '🦄',
  '🦓',
  '🕳️',
  '🌀',
  '😵‍💫',
  '🥴',
  '🫠',
  '🤯',
  '😴',
  '🛸',
  '👽',
  '👾',
  '🤖',
  '😶‍🌫️',
  '🌫️',
  '👨‍🚀',
  '👩‍🚀',
  '🛰️',
  '⏳',
  '🕰️',
  '❓',
  '⁉️',
  '🧱',
  '📺',
  '🌬️',
  '🎶',
  '🎵',
  '🔊',
  '🔉',
  '🔈',
  '🎧',
  '🎤',
  '🕺',
  '💃',
  '🥳',
  '🎉',
  '🎊',
  '✨',
  '🌟',
  '💫',
  '🎆',
  '🎇',
  '🎪',
  '🏕️',
  '⛺',
  '🪩',
  '😎',
  '🤘',
  '🙌',
  '🔥',
  '🎟️',
  '🎡',
  '🎢',
  '🍻',
  '🥂',
  '🌙',
  '🌕',
  '🌃',
  '🌈',
  '🌌',
  '🪐',
  '☄️',
  '🍄',
  '🌵',
  '🦋',
  '🐛',
  '🐌',
  '🐸',
  '💎',
  '🔮',
  '🧿',
  '🧬',
  '⚗️',
  '🧪',
  '👁️',
  '🎨',
  '🌺',
  '🌸',
  '🌼',
  '🌷',
  '🌲',
  '🌳',
  '🐉',
  '🐲',
  '🐙',
  '🦑',
  '🕸️',
  '🌊',
  '🧠',
  '👁️‍🗨️',
  '💭',
  '💤',
  '⚡',
  '💥',
  '💧',
  '〰️',
  '➰',
  '➿',
  '🧩',
  '🗝️',
  '🚪',
  '♾️',
  '📉',
  '📈',
  '👻',
  '🤡',
  '🎭',
  '🤩',
  '🤪',
  '🤤',
  '😇',
  '🤠',
  '🥱',
  '😵',
  '🗿',
  '😮',
  '😲',
];
